import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetTrainingsMainGroupDefinitionsResult } from './get-trainings-main-group-definitions.result';

export async function getTrainingsMainGroupDefinitions(): Promise<GetTrainingsMainGroupDefinitionsResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetTrainingsMainGroupDefinitionsResult[]>(`/firms/trainings/main-group-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
